import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

interface StyledInnerContainerProps {
  selectedValue?: string;
  error?: string;
  isOpen: boolean;
}

export const StyledOuterContainer = styled.div<{ disabled?: boolean }>`
  width: 100%;
  ${({ disabled }) => disabled && `opacity: 0.8; pointer-events: none;`};
`;

export const StyledInnerContainer = styled.div<StyledInnerContainerProps>`
  height: 45px;

  display: flex;
  position: relative;

  & > :nth-child(1):focus + :nth-child(2) {
    height: 11px;
    ${({ selectedValue, error }) =>
      (error || selectedValue) && `color:#A6A1AD;`};
    color: ${DIGIPOSTHEME.colors.primaryBlack};

    font-size: 12px;
    transform: translate(0px, -13px);
    transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
      transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    background-color: white;
  }

  & > :nth-child(2) {
    ${({ selectedValue, error, isOpen }) => {
      return (
        (error || selectedValue || isOpen) &&
        `
      padding-right: 3px;
      padding-left: 2px;
      height: 11px;
      font-size: 12px;
      transform: translate(0px, -13px);
      background-color: white;
      transition: color 200ms cubic-bezier(0, 0, 0.2, 1) 0ms,
      transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;`
      );
    }}
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    flex-direction: column;

    margin-top: 0;
  }
`;

export const SelectScrollWrapper = styled.div<{ isOpen: boolean }>`
  width: 100%;

  position: absolute;
  display: flex;
  flex-direction: column;

  outline: 0;

  ${({ isOpen }) =>
    isOpen &&
    `
    & > :last-child {
    max-height: 150px;
    border-top: 0;
    border-radius: 5px;
    box-sizing: border-box;

    box-shadow: 0px 0px 4px 0px #999975;
  }`}

  &:focus > :nth-child(1) {
    ${({ theme }) =>
      `border: solid 1px ${theme.colors.secondaryGraySecondary}`};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    margin-left: 0;
  }
`;

interface StyledSelectProps {
  inputSize?: "small" | "medium";
  isOpen?: boolean;
  error?: string;
  disabled?: boolean;
}

export const StyledSelectContainer = styled.div<StyledSelectProps>`
  width: 100%;
  height: 45px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 10px 8px 9px 10px;

  font-family: "Campton";

  background-color: ${DIGIPOSTHEME.colors.white};

  border: solid 1px
    ${({ theme, error, isOpen }) => {
      if (error) {
        return theme.colors.validationError;
      }

      if (isOpen) {
        return theme.colors.secondaryGraySecondary;
      }

      return theme.colors.inputBorder;
    }};

  box-sizing: border-box;
  outline: none;

  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    `pointer-events: none;   
  cursor: none;`}
`;

export const StyledIconContainer = styled.div`
  display: flex;
`;

export const StyledSelectedValue = styled.div<{ disabled?: boolean }>`
  display: flex;
  justify-content: flex-start;

  font-size: 14px;
  font-weight: 500;
  font-family: "Campton";
  ${({ disabled }) => disabled && `color: ${DIGIPOSTHEME.colors.darkGrey}`};

  overflow: hidden;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 1px 0px 0px 1px;

    font-size: 12px;
  }
`;

interface OptionsContainer {
  isOpen: boolean;
  inputSize?: "small" | "medium";
  selectedIndex: number;
}

export const StyledOptionsContainer = styled.div<OptionsContainer>`
  display: flex;
  flex-direction: column;

  font-weight: bold;

  & > :nth-child(${({ selectedIndex }) => selectedIndex + 1}) {
    background-color: ${DIGIPOSTHEME.colors.secondaryGrayTertiary};

    &:hover {
      background-color: ${DIGIPOSTHEME.colors
        .secondaryGrayTertiary} !important ;
    }
  }
`;

interface StyledOptionProps {
  inputSize?: "small" | "medium";
  isOpen: boolean;
}

export const StyledOption = styled.div<StyledOptionProps>`
  height: 50px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;

  font-size: 14px;
  font-family: "Campton";

  padding: 15px 8px 15px 7px;

  background-color: ${DIGIPOSTHEME.colors.white};
  outline: none;

  cursor: pointer;

  &:hover {
    background-color: ${DIGIPOSTHEME.colors.secondaryGrayTertiary};
  }

  @media ${MEDIA_QUERIES.MOBILE} {
    font-size: 12px;
  }
`;
